/**
 * @name AgendaModulePlugIn.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\AgendaModulePlugIn.js
 */

import Swal from 'sweetalert2';
var getBaseDir = null, apiCall = null;

$(function()
{
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'agenda/encaixe')
            return;

        new AgendaPlugIn(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class AgendaPlugIn
{
    constructor(onloadList=false, deps = {})
    {
        this.deps = deps;
        this.selectedBranch = -1;
        this.selectedPatient = false;
        this.businessPlans = [];
        let self = this;

        if (document.referrer) {
            $('.js-agenda-create-plug-in-date-go-back-button').removeClass('d-none');
            $('.js-agenda-create-plug-in-date-go-back-button').on('click', function() {
                window.location.href = document.referrer;
            });
        }

        // Resgata lista de serviços
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/patient_type',
            successCallback: function(res) {
                console.log('AgendaModulePlugIn.js/business/patient_type', 'onLoad', res);

                if (res.error) {
                    
                } else {
                    let html = '<option selected default value="">-- Selecione --</option>';
                    let html2 = '<option selected default value="">-- Selecione --</option>';
                    for(let i in res.data) {
                        let serviceObj = res.data[i];
                        html += `
                            <option value="${serviceObj.DESCRICAO}">${serviceObj.DESCRICAO}</option>
                        `;
                        html2 += `
                            <option value="${serviceObj.ID}">${serviceObj.SIGLA}</option>
                        `;
                    }
                    $('.js-agenda-plug-in-select-open-hour-categories').html(html);
                    $('.js-agenda-plug-in-select-patient-type').html(html2);
                }
            },
            errorCallback(err) {
                console.error('ERROR', 'AgendaModulePlugIn.js/business/patient_type', 'onLoad', err);
            }
        });

        this.bindDOMAgendaPlugInForm();
    }

    bindDOMAgendaPlugInForm() {
        $(document).on('change', 'select[name="agenda_plugin_category"]', function(e) {
            let category = $(this).val();
            let patientType = category.split(" ");
            $('select[name="agenda_plugin_patient_type"] option').filter(function() {
                //may want to use $.trim in here
                return $(this).text() != patientType[1];
            }).attr('selected', false);
            $('select[name="agenda_plugin_patient_type"] option').filter(function() {
                //may want to use $.trim in here
                return $(this).text() == patientType[1];
            }).attr('selected', true);
        });

        $(document).on('submit', '.js-agenda-insert-plug-in-date', function(e) {
            e.preventDefault();

            let serializeData = $(this).serializeArray();

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/agenda/insert_plug_in',
                data: serializeData,
                formBlockContainer: '.js-agenda-insert-plug-in-date',
                formElement: '.js-agenda-insert-plug-in-date',
                successCallback: function(res) {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })

                    Swal.fire({
                        icon: res.error ? 'error' : 'success',
                        title: res.error ? 'Erro' : 'Sucesso',
                        text: res.message,
                        showConfirmButton: false
                    });

                    if (!res.error) {
                        $('.js-agenda-insert-plug-in-date').trigger('reset');
                    }
                },
                errorCallback: function(err) {
                }
            });
        });
    }
}